<div class="career-container">
    <div class="content-centered">
        <h1 class="career-title">{{'CAREER_TITLE' | translate}}</h1>
    </div>
</div>
<div class="career">
    <section class="career-section">
        <h2 class="career-sub">{{'CAREER_S1' | translate}}</h2>
        <p class="career-sub-parag">{{'CAREER_C1_1' | translate}}</p>
    </section>
    <section class="career-section highlights">
        <div class="career-high">
            <div class="high__icon">
                <img src="assets/images/location.svg" alt="">
            </div>
            <div class="high__amount">+60</div>
            <div class="high__name">{{'CAREER_POINTS' | translate}}</div>
        </div>
        <div class="career-high">
            <div class="high__icon">
                <img src="assets/images/cityscape.svg" alt="">
            </div>
            <div class="high__amount">+10</div>
            <div class="high__name">{{'CAREER_CITIES' | translate}}</div>
        </div>
        <div class="career-high">
            <div class="high__icon">
                <img src="assets/images/network.svg" alt="">
            </div>
            <div class="high__amount">+300</div>
            <div class="high__name">{{'CAREER_COWORKERS' | translate}}</div>
        </div>
        <div class="career-high">
            <div class="high__icon">
                <img src="assets/images/location.svg" alt="">
            </div>
            <div class="high__amount">+25</div>
            <div class="high__name">{{'CAREER_NATIONALITIES' | translate}}</div>
        </div>
    </section>
    <section class="career-section">
        <h2 class="career-sub">{{'CAREER_S3' | translate}}</h2>
        <p class="career-sub-parag">{{'CAREER_C3' | translate}}</p>
    </section>
    <section class="career-section information">
        <div class="career-info">
            <div class="info__image">
                <img src="assets/images/career_info_01.png" alt="">
            </div>
            <div class="info__title">
                {{'CAREER_S4_1' | translate}}
            </div>
            <div class="info__description">{{'CAREER_C4_1' | translate}}</div>
        </div>
        <div class="career-info">
            <div class="info__image">
                <img src="assets/images/career_info_02.png" alt="">
            </div>
            <div class="info__title">
                {{'CAREER_S4_2' | translate}}
            </div>
            <div class="info__description">{{'CAREER_C4_2' | translate}}</div>
        </div>
    </section>
    <section class="career-section">
        <h1 class="career-sub">{{'CAREER_TITLE_2' | translate}}</h1>
    </section>
    <section class="career-section form">
        <iframe src="https://careers.cityexpert.travel/jobs_preview" frameborder="0" allowfullscreen></iframe>
    </section>
    <section class="career-section banner">
        <div class="career-banner">
            <div class="banner__image">
                <img src="assets/images/career_banner_01.png" alt="">
            </div>
            <div class="banner__body">
                <div class="body__title">
                    {{'CAREER_S6' | translate}}
                </div>
                <div class="body__description">
                    {{'CAREER_C6' | translate}}
                    <div>
                        <a class="career__anchor" target="_blank" href="mailto:personas@cityexpert.travel">{{'CAREER_S7' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>